// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/feedback',
    name: 'Feedback',
    component: layout,
    redirect: '/feedback/index',
    meta: {
      title: '反馈管理',
      roles: [0]
    },
    sort: 4,
    children: [
      {
        path: 'index',
        name: 'FeedbackIndex',
        component: () => import('@/views/Manage/Feedback.vue'),
        meta: {
          title: '反馈列表',
          icon: 'i-tabler:file-text-shield',
          roles: [0]
        }
      }
    ]
  }
]
export default routes
